module.exports = __webpack_public_path__ + "7ded98a150e49a5c326f10e44e208ad0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/community-workouts-gradient.png
// module id = 1867
// module chunks = 1